import { render, staticRenderFns } from "./ModelXHeader.vue?vue&type=template&id=2ea46e22&scoped=true&"
import script from "./ModelXHeader.vue?vue&type=script&lang=js&"
export * from "./ModelXHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea46e22",
  null
  
)

export default component.exports